module.exports = __webpack_public_path__ + "static/media/2. Priscilla.de2b3ee8.png";